module.exports = __webpack_public_path__ + "img/vannforekomster.c4bf1a24.jpg";